import * as S from '@effect/schema/Schema';
import { AdvocateTag, nullable, withFallback } from '@infl-ts/util-io-ts';
import * as t from 'io-ts'; // Re-export the Atlas tag codecs from the shared util so callers
// importing from this module still find them. The codec itself is
// defined once in @infl-ts/util-io-ts to keep profile/ and
// profile-popover/ from drifting.

export { AdvocateTag, Taxonomy, TaxonomyTerm } from '@infl-ts/util-io-ts';
var Member = t.type({
  id: t.string,
  name: t.string,
  isAdmin: t["boolean"],
  title: nullable(t.string),
  company: nullable(t.string),
  avatarUrl: nullable(t.string),
  // Atlas tags: wrap in withFallback so a Hub HTTP failure on the Go
  // resolver (Member.tags returns null) degrades to "0 chips rendered"
  // instead of failing the WHOLE Member decode and 500ing the profile.
  tags: withFallback(t.array(AdvocateTag), [])
});
var SocialAccountBase = t.type({
  id: t.string,
  connected: t["boolean"],
  visible: t["boolean"]
});
var SocialAccountWithProfileUrl = t.type({
  __typename: t.keyof({
    Facebook: null,
    Linkedin: null,
    Twitter: null
  }),
  profileUrl: nullable(t.string)
});
var SocialAccount = t.intersection([t.union([SocialAccountWithProfileUrl, t.type({
  __typename: t.keyof({
    Apple: null,
    OAuth2: null,
    Google: null
  })
})]), SocialAccountBase], 'SocialAccount');
export var VisibleSocialAccount = t.intersection([t.union([SocialAccountWithProfileUrl, t.type({
  __typename: t.keyof({
    Apple: null,
    OAuth2: null
  })
})]), SocialAccountBase], 'VisibleSocialAccount');
var Profile = t.type({
  id: t.string,
  isAdmin: t["boolean"],
  isClone: t["boolean"],
  socialAccounts: t.array(SocialAccount)
});
export var MemberQuery = t.type({
  member: Member,
  profile: Profile
});
export var ProfileBlockConfig = S.struct({
  typename: S.literal('ProfileBlock'),
  id: S.string,
  hash: S.string,
  memberId: S.string
});